/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContractMedications } from './ContractMedications';
import {
    ContractMedicationsFromJSON,
    ContractMedicationsFromJSONTyped,
    ContractMedicationsToJSON,
} from './ContractMedications';
import type { ContractRubric } from './ContractRubric';
import {
    ContractRubricFromJSON,
    ContractRubricFromJSONTyped,
    ContractRubricToJSON,
} from './ContractRubric';

/**
 * 
 * @export
 * @interface StructuredContract
 */
export interface StructuredContract {
    /**
     * 
     * @type {string}
     * @memberof StructuredContract
     */
    subtype: StructuredContractSubtypeEnum;
    /**
     * 
     * @type {Array<ContractRubric>}
     * @memberof StructuredContract
     */
    rubrics: Array<ContractRubric>;
    /**
     * 
     * @type {ContractMedications}
     * @memberof StructuredContract
     */
    medications: ContractMedications;
    /**
     * 
     * @type {Array<string>}
     * @memberof StructuredContract
     */
    equipment: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StructuredContract
     */
    other_exceptions: Array<string>;
}


/**
 * @export
 */
export const StructuredContractSubtypeEnum = {
    Tiers: 'tiers',
    Categories: 'categories'
} as const;
export type StructuredContractSubtypeEnum = typeof StructuredContractSubtypeEnum[keyof typeof StructuredContractSubtypeEnum];


/**
 * Check if a given object implements the StructuredContract interface.
 */
export function instanceOfStructuredContract(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "subtype" in value;
    isInstance = isInstance && "rubrics" in value;
    isInstance = isInstance && "medications" in value;
    isInstance = isInstance && "equipment" in value;
    isInstance = isInstance && "other_exceptions" in value;

    return isInstance;
}

export function StructuredContractFromJSON(json: any): StructuredContract {
    return StructuredContractFromJSONTyped(json, false);
}

export function StructuredContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredContract {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtype': json['subtype'],
        'rubrics': ((json['rubrics'] as Array<any>).map(ContractRubricFromJSON)),
        'medications': ContractMedicationsFromJSON(json['medications']),
        'equipment': json['equipment'],
        'other_exceptions': json['other_exceptions'],
    };
}

export function StructuredContractToJSON(value?: StructuredContract | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtype': value.subtype,
        'rubrics': ((value.rubrics as Array<any>).map(ContractRubricToJSON)),
        'medications': ContractMedicationsToJSON(value.medications),
        'equipment': value.equipment,
        'other_exceptions': value.other_exceptions,
    };
}

